export default {
  Dashboard: "Dashboard",
  "All Jobs": "All Jobs",
  Experience: "Experience",
  Back: "Back",
  "Duties and Responsibilities": "Duties and Responsibilities",
  "Qualifications / Requirements": "Qualifications / Requirements",
  "Required Documents": "Required Documents",
  "Please submit the following documents in a single PDF file":
    "Please submit the following documents in a single PDF file",
  "Delete This Job": "Delete This Job",
  "Loading Job Details": "Loading Job Details",
  "No data available for this job": "No data available for this job",
  "Loading Jobs": "Loading Jobs",
  "No Jobs Available": "No Jobs Available",
  Career: "Career",
  "Post Job": "Post Job",
  Menu: "Menu",
  "Add New Job Role": "Add New Job Role",
  English: "English",
  Arabic: "Arabic",
  "Job Title": "Job Title",
  "Job Type": "Job Type",
  Experience: "Experience",
  Browse: "Browse",
  "Supported formates: Ico, PNG": "Supported formates: Ico, PNG",
  Description: "Description",
  "Location/Region": "Location/Region",
  Duties: "Duties",
  "Required Documents": "Required Documents",
  Qualifications: "Qualifications",
  Submit: "Submit",
  "Select Job Type": "Select Job Type",
  "Full Time": "Full Time",
  "Part Time": "Part Time",
  Contract: "Contract",
  Internship: "Internship",
  "First Name": "First Name",
  "Family Name": "Family Name",
  "Date of Birth": "Date of Birth",
  Nationality: "Nationality",
  Residence: "Residence",
  Email: "Email",
  Phone: "Phone",
  Degree: "Degree",
  Major: "Major",
  "Notice Period": "Notice Period",
  Resume: "Resume",
  "Export to Excel": "Export to Excel",
  Applicants: "Applicants",
  "All Applicants": "All Applicants",
  "Download Resume": "Download Resume",
  "View Applicants": "View Applicants",
  "Job is not available in": "Job is not available in",
  "Are you sure you want to delete the job":
    "Are you sure you want to delete the job",
  Cancel: "Cancel",
  Confirm: "Confirm",
  "Sign in to your account": "Sign in to your account",
  "User Name": "User Name",
  Password: "Password",
  "Sign in": "Sign in",
  Actions: "Actions",
};
